import { RootState } from '@reducers';

export const selectCancerQuotePaymentPage = (state: RootState) => state.cancerQuotePaymentPageReducer;
